export default __webpack_public_path__ + "static/media/no-order.40ed83ff.svg";